import {ExpandMore} from "@mui/icons-material";
import {Accordion, AccordionDetails, AccordionSummary, Grid, TextField} from "@mui/material";
import * as React from "react";
import {useState} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {useRecoilValue} from "recoil";
import {EDITING} from "../../../../service/FinesSecurityRecoil";
import {DatePicker} from "@mui/x-date-pickers";
import {STATUS_FOUND, STATUS_RELEASE, STATUS_UNDER_SEIZURE} from "../../../../component/Constants";

const PlaceFound = (props: any) => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'theftMisappropriate'});
    const [isExpanded, setIsExpanded] = useState(true);
    const {register, control, watch}  = useFormContext();
    const editing = useRecoilValue(EDITING);

    function checkStatus(statusCode: number){
        if(editing){
            return  statusCode === STATUS_RELEASE ? watch("eventStatus.eventStatusCode") !== STATUS_RELEASE || !!props.theftMisappropriate?.placeReleaseDatetime :
                      statusCode === STATUS_UNDER_SEIZURE ? watch("eventStatus.eventStatusCode") !== STATUS_UNDER_SEIZURE || !!props.theftMisappropriate?.underSeizureDatetime :
                    statusCode === STATUS_FOUND ? watch("eventStatus.eventStatusCode") !== STATUS_FOUND || !!props.theftMisappropriate?.placeFoundDatetime : true;
        } else {
            return true;
        }
    }

    return (
        <Accordion defaultExpanded={true}  onChange={(_e,expanded) => {
            setIsExpanded(expanded); 
        }}>
            <AccordionSummary expandIcon={<ExpandMore/>}>
                <Grid item md={6} xs={6}>
                    {t("tabs.placeFound") }
                </Grid>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container columnSpacing={3} rowSpacing={1}>
                    <Grid item  xs={3}>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            disabled={!editing}
                            id="placeCountry"
                            label={t("eventCard.country")}
                            type="text"
                            {...register("placeCountry")}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            disabled={!editing}
                            id="placeRegion"
                            label={t("eventCard.region")}
                            type="text"
                            {...register("placeRegion")}
                        />
                    </Grid>
                    <Grid item  xs={3}>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            disabled={!editing}
                            id="placeCity"
                            label={t("eventCard.city")}
                            type="text"
                            {...register("placeCity")}
                        />
                    </Grid>
                    <Grid item  xs={3}>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            disabled={!editing}
                            id="placeAddress"
                            label={t("eventCard.address")}
                            type="text"
                            {...register("placeAddress")}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={"placeFoundDatetime"}
                            render={({field, fieldState}) => (
                                <DatePicker
                                    label={t("eventCard.dateFound")}
                                    value={field.value}
                                    onChange={field.onChange}
                                    disabled={checkStatus(STATUS_FOUND)}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            disabled={checkStatus(STATUS_FOUND)}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}/>
                                    }
                                    inputFormat={"L"}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={"underSeizureDatetime"}
                            render={({field, fieldState}) => (
                                <DatePicker
                                    label={t("eventCard.dateOfSeizure")}
                                    value={field.value}
                                    onChange={field.onChange}
                                    disabled={checkStatus(STATUS_UNDER_SEIZURE)}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            disabled={checkStatus(STATUS_UNDER_SEIZURE)}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}/>
                                    }
                                    inputFormat={"L"}
                                />
                            )}
                        />
                    </Grid>

                    <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={"placeReleaseDatetime"}
                            render={({field, fieldState}) => (
                                <DatePicker
                                    label={t("eventCard.dateOfRelease")}
                                    value={field.value}
                                    onChange={field.onChange}
                                    disabled={checkStatus(STATUS_RELEASE)}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            disabled={checkStatus(STATUS_RELEASE)}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}/>
                                    }
                                    inputFormat={"L"}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <Controller
                            control={control}
                            name={"placeReportOfReturnDatetime"}
                            render={({field, fieldState}) => (
                                <DatePicker
                                    label={t("eventCard.dateReportOfReturn")}
                                    value={field.value}
                                    onChange={field.onChange}
                                    disabled={!editing}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            disabled={!editing}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}/>
                                    }
                                    inputFormat={"L"}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item  xs={3}>
                        <TextField
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            disabled={!editing}
                            id="reportAuthority"
                            label={t("eventCard.reportAuthority")}
                            type="text"
                            {...register("reportAuthority")}
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default PlaceFound;